import { useAuthStore } from "@/store/use-auth-store";
import { AdminDashboard } from "@/components/dashboard/admin-dashboard";
import { UserDashboard } from "@/components/dashboard/user-dashboard";

const Home = () => {
  const { roles } = useAuthStore();
  const isAdmin = !!roles?.includes("Admin");

  return isAdmin ? <AdminDashboard /> : <UserDashboard />;
};

export default Home;
